import React from "react";
import { compose, defaultProps } from "recompose";

import { Button } from "./style";

export default compose(defaultProps({ size: 60, alt: "" }))(Button);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/components/RoundedButton/index.js
// module id = 103
// module chunks = 0